import { 
  Users, 
  Globe, 
  Phone, 
  Mail, 
  Wrench,
  Briefcase,
  Megaphone,
  ArrowUpDown 
} from "lucide-react";
import { IconMapping } from "./types";

export const getLeadSourceIcon = (key: string): IconMapping => {
  const normalizedKey = key.toLowerCase();
  
  if (normalizedKey.includes('referral')) {
    return { icon: Users, color: "text-purple-600" };
  }
  
  if (normalizedKey.includes('website') || normalizedKey.includes('corporate')) {
    return { icon: Globe, color: "text-purple-600" };
  }
  
  if (normalizedKey.includes('call') || normalizedKey.includes('phone')) {
    return { icon: Phone, color: "text-purple-600" };
  }
  
  if (normalizedKey.includes('email') || normalizedKey.includes('mail')) {
    return { icon: Mail, color: "text-purple-600" };
  }
  
  if (normalizedKey.includes('service')) {
    return { icon: Wrench, color: "text-purple-600" };
  }

  if (normalizedKey.includes('social') || normalizedKey.includes('meta')) {
    return { icon: Megaphone, color: "text-purple-600" };
  }

  if (normalizedKey.includes('broker') || normalizedKey.includes('agent')) {
    return { icon: ArrowUpDown, color: "text-purple-600" };
  }
  
  return { icon: Briefcase, color: "text-purple-600" };
};